<template>
  <div class="container">
    <div class="row">
      <div class="col-md p-2">
        <div class="bg-light rounded p-2">
          <h1>Questions</h1>
          <hr />
          <!-- <div class="container">
            <div class="">
              <button @click="downloadFile('images')" class="btn btn-block btn-info mt-2">Télécharger les images actuelles</button>
            </div>
          </div>
          <hr> -->
          <div class="container">
            <p class="font-weight-bold mb-1">Mettre à jour les questions</p>
            <p class="text-secondary">
              Envoyez un fichier contenant les
              <strong>nouvelles questions</strong> par défaut.
            </p>
            <input
              type="file"
              id="file"
              ref="file"
              v-on:change="handleFileUpload()"
            />
            <div class="d-flex justify-content-start mb-2">
              <button v-on:click="submitFile()" class="btn btn-primary mt-2">
                Envoyer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'Questions',
    props: [],
    data() {
      return {
        file: null,
      }
    },
    methods: {
      handleFileUpload() {
        this.file = this.$refs.file.files[0]
      },

      submitFile() {
        const token = localStorage.getItem('jwt')
        if (token) {
          let formData = new FormData()
          formData.append('excel', this.file)
          axios
            .post('/questions/upload', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: 'Bearer ' + token,
              },
            })
            .then(() => {
              console.log('Excel file uploaded')
              this.$notify({
                type: 'success',
                title: 'Upload réalisé avec succès',
                text: 'Les questions ont été mis à jour.',
              })
            })
            .catch((err) => {
              console.log('Failed to upload Excel file', err)
              this.$notify({
                type: 'error',
                title: "Echec de l'upload",
                text: err || 'Erreur inconnue.',
              })
            })
        } else {
          this.$router.push('/login')
        }
      },
    },
  }
</script>

<style></style>
